/* ============================================================================
   Sixth Aura — Theme interactions (Shopify port)
   Header scroll state, cart drawer (Shopify AJAX), mobile menu drawer,
   full-screen search overlay, scroll reveal animations, PDP size selector.
   ============================================================================ */
(function () {
  'use strict';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Format cents using the shop's money format when available, else a sane fallback.
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var fmt = window.SA_MONEY_FORMAT;
    if (fmt && typeof fmt === 'string') {
      // Replace {{ amount }} / {{ amount_no_decimals }} / {{ amount_with_comma_separator }} tokens.
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, token) {
        if (token.indexOf('no_decimals') !== -1) return Math.round(cents / 100).toString();
        return amount;
      });
    }
    return '₹' + amount;
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  document.addEventListener('DOMContentLoaded', function () {
    /* ====================================================
       1. HEADER SCROLL STATE
       ==================================================== */
    var header = qs('.Header');
    if (header) {
      var toggleScrolled = function () {
        if (window.scrollY > 40) {
          header.classList.add('Header--scrolled');
        } else {
          header.classList.remove('Header--scrolled');
        }
      };
      window.addEventListener('scroll', toggleScrolled, { passive: true });
      toggleScrolled();
    }

    /* ====================================================
       2. MOBILE MENU DRAWER
       ==================================================== */
    var mobileMenu = qs('#mobile-menu-drawer');
    function openMobileMenu() { if (mobileMenu) mobileMenu.classList.add('is-open'); }
    function closeMobileMenu() { if (mobileMenu) mobileMenu.classList.remove('is-open'); }

    var menuToggle = qs('#menu-toggle-btn');
    var menuClose = qs('#mobile-menu-close-btn');
    var menuOverlay = qs('#mobile-menu-overlay');
    if (menuToggle) menuToggle.addEventListener('click', openMobileMenu);
    if (menuClose) menuClose.addEventListener('click', closeMobileMenu);
    if (menuOverlay) menuOverlay.addEventListener('click', closeMobileMenu);

    /* ====================================================
       3. SEARCH OVERLAY
       ==================================================== */
    var searchOverlay = qs('#search-overlay');
    var searchInput = qs('.SearchOverlay__Input');
    function openSearch() {
      if (!searchOverlay) return;
      searchOverlay.classList.add('is-open');
      setTimeout(function () { if (searchInput) searchInput.focus(); }, 300);
    }
    function closeSearch() { if (searchOverlay) searchOverlay.classList.remove('is-open'); }

    var searchTrigger = qs('#nav-search-trigger');
    var searchClose = qs('#search-close-btn');
    if (searchTrigger) searchTrigger.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
    if (searchClose) searchClose.addEventListener('click', closeSearch);

    /* ---- Predictive instant search ---- */
    var searchResults = qs('#search-results');
    var searchForm = qs('.SearchOverlay__Form');
    var searchUrl = (searchForm && searchForm.getAttribute('action')) || '/search';

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function searchSkeletonHTML() {
      var row = '<div class="search-skeleton-row"><div class="search-skeleton-lines">' +
        '<span></span><span></span></div></div>';
      return row + row + row;
    }

    function renderSearchResults(data, term) {
      if (!searchResults) return;
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
      var viewAll = searchUrl + '?q=' + encodeURIComponent(term);

      if (!products.length && !collections.length) {
        searchResults.innerHTML = '<div class="search-state">No matches for “' + escapeHtml(term) + '”</div>' +
          '<a class="search-view-all" href="' + viewAll + '">Search all products for “' + escapeHtml(term) + '”</a>';
        return;
      }

      var html = '';
      if (products.length) {
        html += '<span class="search-results-group-label">Products</span>';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          var imgTag = img
            ? '<img class="search-result-img" src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" width="52" height="65" loading="lazy">'
            : '<span class="search-result-img"></span>';
          var price = (typeof p.price !== 'undefined' && p.price !== null) ? formatMoney(p.price) : '';
          html += '<a class="search-result" href="' + escapeHtml(p.url) + '">' +
            imgTag +
            '<span class="search-result-body">' +
              '<span class="search-result-title">' + escapeHtml(p.title) + '</span>' +
              (price ? '<span class="search-result-price">' + price + '</span>' : '') +
            '</span>' +
          '</a>';
        });
      }
      if (collections.length) {
        html += '<span class="search-results-group-label">Collections</span><div>';
        collections.forEach(function (c) {
          html += '<a class="search-collection-link" href="' + escapeHtml(c.url) + '">' + escapeHtml(c.title) + '</a>';
        });
        html += '</div>';
      }
      html += '<a class="search-view-all" href="' + viewAll + '">View all results for “' + escapeHtml(term) + '”</a>';
      searchResults.innerHTML = html;
    }

    if (searchInput && searchResults) {
      var searchTimer = null;
      var lastTerm = '';
      searchInput.addEventListener('input', function () {
        var term = searchInput.value.trim();
        if (searchTimer) clearTimeout(searchTimer);
        if (term.length < 2) { searchResults.innerHTML = ''; lastTerm = ''; return; }
        if (term === lastTerm) return;
        searchResults.innerHTML = '<div class="search-state">Searching…</div>' + searchSkeletonHTML();
        searchTimer = setTimeout(function () {
          lastTerm = term;
          var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
            '&resources[type]=product,collection&resources[limit]=6' +
            '&resources[options][unavailable_products]=last';
          fetch(url, { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (searchInput.value.trim() !== term) return;
              renderSearchResults(data, term);
            })
            .catch(function () {
              if (searchResults) {
                searchResults.innerHTML = '<a class="search-view-all" href="' +
                  searchUrl + '?q=' + encodeURIComponent(term) + '">View all results for “' + escapeHtml(term) + '”</a>';
              }
            });
        }, 250);
      });
    }

    /* ====================================================
       4. CART DRAWER (Shopify AJAX)
       ==================================================== */
    var cartDrawer = qs('#cart-drawer');
    var cartBody = qs('#cart-body');
    var cartFooter = qs('#cart-footer');
    var cartSubtotal = qs('.cart-subtotal-value');
    var bagCounts = qsa('.bag-count');

    var freeShipThreshold = 0;
    var cartCurrency = 'USD';
    if (cartDrawer) {
      freeShipThreshold = parseFloat(cartDrawer.getAttribute('data-free-shipping-threshold')) || 0;
      cartCurrency = cartDrawer.getAttribute('data-currency') || cartCurrency;
    }

    function cartSkeletonHTML() {
      var row = '<div class="cart-skeleton-row"><div class="cart-skeleton-lines">' +
        '<span></span><span></span><span></span></div></div>';
      return '<div class="cart-skeleton">' + row + row + row + '</div>';
    }

    function freeShipHTML(totalCents) {
      if (!freeShipThreshold || freeShipThreshold <= 0) return '';
      var thresholdCents = freeShipThreshold * 100;
      var remaining = thresholdCents - totalCents;
      var pct = Math.max(0, Math.min(100, (totalCents / thresholdCents) * 100));
      var text;
      var unlockedClass = '';
      if (remaining > 0) {
        text = 'Add <strong>' + formatMoney(remaining) + '</strong> for free shipping';
      } else {
        text = '&#10003; You’ve unlocked free shipping';
        unlockedClass = ' is-unlocked';
        pct = 100;
      }
      return '<div class="cart-freeship">' +
        '<span class="cart-freeship-text' + unlockedClass + '">' + text + '</span>' +
        '<div class="cart-freeship-bar"><div class="cart-freeship-fill" style="width:' + pct + '%"></div></div>' +
        '</div>';
    }

    function openCart() { if (cartDrawer) cartDrawer.classList.add('is-open'); }
    function closeCart() { if (cartDrawer) cartDrawer.classList.remove('is-open'); }

    var bagTrigger = qs('#nav-bag-trigger');
    var cartClose = qs('#cart-close-btn');
    var cartOverlay = qs('#cart-overlay');
    if (bagTrigger) bagTrigger.addEventListener('click', function (e) { e.preventDefault(); openCart(); renderCart(true); });
    if (cartClose) cartClose.addEventListener('click', closeCart);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

    function updateBagCount(count) {
      bagCounts.forEach(function (el) { el.textContent = count; });
    }

    function buildCartItem(item) {
      var img = item.image
        ? '<img class="cart-item-img" src="' + item.image + '" alt="' + (item.product_title || '') + '" />'
        : '<span class="cart-item-img"></span>';
      var meta = '';
      if (item.variant_title && item.variant_title.toLowerCase() !== 'default title') {
        meta = '<span class="cart-item-meta">' + item.variant_title + '</span>';
      }
      return '' +
        '<div class="cart-item">' +
          img +
          '<div class="cart-item-details">' +
            '<div>' +
              '<h3 class="cart-item-title">' + item.product_title + '</h3>' +
              meta +
            '</div>' +
            '<div class="cart-item-quantity-row">' +
              '<div class="cart-qty-btn-group">' +
                '<button class="cart-qty-btn" data-line="' + item.line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">-</button>' +
                '<span class="cart-qty-value">' + item.quantity + '</span>' +
                '<button class="cart-qty-btn" data-line="' + item.line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
              '</div>' +
              '<button class="cart-item-remove" data-line="' + item.line + '" data-qty="0">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }

    function renderCartData(cart) {
      updateBagCount(cart.item_count);
      if (!cartBody) return;

      if (!cart.items || cart.items.length === 0) {
        cartBody.innerHTML = '<div class="cart-empty-message">Your shopping bag is empty.</div>';
        if (cartFooter) cartFooter.style.display = 'none';
        return;
      }

      var html = freeShipHTML(cart.total_price);
      cart.items.forEach(function (item, i) {
        item.line = i + 1;
        html += buildCartItem(item);
      });
      cartBody.innerHTML = html;
      if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price) + ' ' + cartCurrency;
      if (cartFooter) cartFooter.style.display = 'block';

      qsa('.cart-qty-btn, .cart-item-remove', cartBody).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = parseInt(btn.getAttribute('data-line'), 10);
          var qty = parseInt(btn.getAttribute('data-qty'), 10);
          changeLine(line, qty);
        });
      });
    }

    function renderCart(showSkeleton) {
      if (showSkeleton && cartBody) cartBody.innerHTML = cartSkeletonHTML();
      fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(renderCartData)
        .catch(function () {});
    }

    function changeLine(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(renderCartData)
        .catch(function () {});
    }

    function addToCart(variantId, quantity) {
      if (!variantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () { openCart(); renderCart(true); })
        .catch(function () {});
    }

    // Initial cart count sync
    renderCart();

    /* ====================================================
       5. ADD TO BAG — product cards
       ==================================================== */
    qsa('.product-quick-add').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = btn.getAttribute('data-variant-id');
        if (variantId) addToCart(variantId, 1);
      });
    });

    /* ====================================================
       6. PDP — variant engine + quantity + add to bag
       ==================================================== */
    var pdpInfo = qs('.product-info-sticky');
    var pdpAddBtn = qs('#pdp-add-to-bag-btn');
    var pdpPrice = qs('#pdp-price');
    var pdpQtyInput = qs('#pdp-qty');
    var pdpStickyBar = qs('#pdp-sticky-bar');
    var pdpStickyAdd = qs('#pdp-sticky-add');
    var pdpStickyPrice = qs('#pdp-sticky-price');

    if (pdpInfo && pdpAddBtn) {
      var productId = pdpInfo.getAttribute('data-product-id');
      var variantsScript = qs('#ProductVariantsJSON-' + productId) ||
        qs('script[id^="ProductVariantsJSON-"]', pdpInfo);
      var variants = [];
      if (variantsScript) {
        try { variants = JSON.parse(variantsScript.textContent) || []; } catch (e) { variants = []; }
      }

      // Initialize selected options from the current/first available variant.
      var currentVariant = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) { currentVariant = variants[i]; break; }
      }
      if (!currentVariant && variants.length) currentVariant = variants[0];
      var selectedOptions = currentVariant ? currentVariant.options.slice() : [];

      function findVariant() {
        for (var v = 0; v < variants.length; v++) {
          var opts = variants[v].options;
          var match = true;
          for (var o = 0; o < selectedOptions.length; o++) {
            if (opts[o] !== selectedOptions[o]) { match = false; break; }
          }
          if (match) return variants[v];
        }
        return null;
      }

      function updatePdpPrice(variant) {
        if (!pdpPrice) return;
        var html = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html = formatMoney(variant.price) +
            ' <s style="opacity:.5;">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        pdpPrice.innerHTML = html;
      }

      function updateGalleryImage(variant) {
        var firstImg = qs('.product-gallery .zoom-gallery-img');
        if (!firstImg || firstImg.tagName !== 'IMG') return;

        // Stash the original src/srcset once so we can restore it when a
        // selected variant has no image of its own.
        if (!firstImg.getAttribute('data-original-src')) {
          firstImg.setAttribute('data-original-src', firstImg.getAttribute('src') || '');
          var origSet = firstImg.getAttribute('srcset');
          if (origSet) firstImg.setAttribute('data-original-srcset', origSet);
        }

        if (variant && variant.featured_image && variant.featured_image.src) {
          firstImg.src = variant.featured_image.src;
          // A single src overrides any responsive srcset that no longer matches.
          if (firstImg.getAttribute('srcset')) firstImg.removeAttribute('srcset');
        } else {
          // No variant image — restore the product's original main image.
          var orig = firstImg.getAttribute('data-original-src');
          if (orig) firstImg.src = orig;
          var origSrcset = firstImg.getAttribute('data-original-srcset');
          if (origSrcset) firstImg.setAttribute('srcset', origSrcset);
        }
      }

      function syncStickyBar(variant) {
        if (variant) {
          if (pdpStickyAdd) {
            pdpStickyAdd.setAttribute('data-variant-id', variant.id);
            pdpStickyAdd.disabled = !variant.available;
            pdpStickyAdd.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
          }
          if (pdpStickyPrice) pdpStickyPrice.textContent = formatMoney(variant.price);
        } else if (pdpStickyAdd) {
          pdpStickyAdd.disabled = true;
          pdpStickyAdd.textContent = 'SOLD OUT';
        }
      }

      function refreshVariant() {
        var variant = findVariant();
        if (variant) {
          pdpAddBtn.setAttribute('data-variant-id', variant.id);
          updatePdpPrice(variant);
          updateGalleryImage(variant);
          if (variant.available) {
            pdpAddBtn.disabled = false;
            pdpAddBtn.textContent = 'ADD TO BAG';
          } else {
            pdpAddBtn.disabled = true;
            pdpAddBtn.textContent = 'SOLD OUT';
          }
        } else {
          pdpAddBtn.disabled = true;
          pdpAddBtn.textContent = 'SOLD OUT';
        }
        syncStickyBar(variant);
      }

      // Option choice buttons (size boxes + swatches).
      qsa('.sa-size-box, .sa-swatch', pdpInfo).forEach(function (choice) {
        choice.addEventListener('click', function () {
          var idx = parseInt(choice.getAttribute('data-option-index'), 10);
          var val = choice.getAttribute('data-option-value');
          if (isNaN(idx)) return;
          var group = qsa('[data-option-index="' + idx + '"][data-option-value]', pdpInfo);
          group.forEach(function (b) { b.classList.remove('is-selected'); });
          choice.classList.add('is-selected');
          selectedOptions[idx] = val;
          var current = qs('[data-option-current="' + idx + '"]', pdpInfo);
          if (current) current.textContent = val;
          refreshVariant();
        });
      });

      // Quantity selector.
      qsa('.sa-qty-btn', pdpInfo).forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!pdpQtyInput) return;
          var dir = parseInt(btn.getAttribute('data-dir'), 10) || 0;
          var val = parseInt(pdpQtyInput.value, 10) || 1;
          val = Math.max(1, val + dir);
          pdpQtyInput.value = val;
        });
      });
      if (pdpQtyInput) {
        pdpQtyInput.addEventListener('change', function () {
          var val = parseInt(pdpQtyInput.value, 10);
          if (isNaN(val) || val < 1) pdpQtyInput.value = 1;
        });
      }

      pdpAddBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = pdpAddBtn.getAttribute('data-variant-id');
        var qty = pdpQtyInput ? (parseInt(pdpQtyInput.value, 10) || 1) : 1;
        if (variantId) addToCart(variantId, qty);
      });

      // Sticky bar add — reads the SAME selected variant + quantity as the main button.
      if (pdpStickyAdd) {
        pdpStickyAdd.addEventListener('click', function (e) {
          e.preventDefault();
          var variantId = pdpAddBtn.getAttribute('data-variant-id');
          var qty = pdpQtyInput ? (parseInt(pdpQtyInput.value, 10) || 1) : 1;
          if (variantId) addToCart(variantId, qty);
        });
      }

      // Initialise sticky price/state from the current variant.
      syncStickyBar(currentVariant);

      // Reveal sticky bar when the main add-to-bag button scrolls out of view.
      if (pdpStickyBar && 'IntersectionObserver' in window) {
        var stickyObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              pdpStickyBar.classList.remove('is-visible');
              pdpStickyBar.setAttribute('aria-hidden', 'true');
            } else {
              pdpStickyBar.classList.add('is-visible');
              pdpStickyBar.setAttribute('aria-hidden', 'false');
            }
          });
        }, { root: null, threshold: 0 });
        stickyObserver.observe(pdpAddBtn);
      }
    }

    /* ====================================================
       7. ESCAPE closes overlays
       ==================================================== */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeCart();
        closeSearch();
        closeMobileMenu();
      }
    });

    /* ====================================================
       8. SCROLL REVEAL ANIMATIONS
       ==================================================== */
    var prefersReducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var STAGGER_CHILD_SELECTOR = '.product-card, .collection-block, .sa-lookbook-item, .MegaMenu__Card';

    // Tag direct child cards so they can stagger in when their container reveals.
    function tagStaggerChildren(container) {
      var children = qsa(STAGGER_CHILD_SELECTOR, container);
      children.forEach(function (child, idx) {
        child.classList.add('scroll-stagger-child');
        if (!prefersReducedMotion) {
          var capped = Math.min(idx, 8);
          child.style.transitionDelay = (capped * 45) + 'ms';
        }
      });
    }

    var animateEls = qsa('.scroll-animate');
    animateEls.forEach(tagStaggerChildren);

    if ('IntersectionObserver' in window && animateEls.length && !prefersReducedMotion) {
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            obs.unobserve(entry.target);
          }
        });
      }, { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.1 });

      animateEls.forEach(function (el) {
        // Reveal immediately if already in view above the fold.
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.classList.add('in-view');
        } else {
          observer.observe(el);
        }
      });
    } else {
      animateEls.forEach(function (el) { el.classList.add('in-view'); });
    }
  });
})();

/* ==========================================
   MEGA-MENU + MOBILE ACCORDION
   ========================================== */
document.addEventListener('DOMContentLoaded', function () {
  // Desktop mega-menu: hover/focus handled by CSS. Add touch + keyboard support.
  var navItems = document.querySelectorAll('.Header__NavItem.has-mega');
  var hoverCapable = window.matchMedia('(hover: hover)').matches;

  var megaOpenTimer = null;
  var megaCloseTimer = null;

  function openItem(item) {
    navItems.forEach(function (i) { if (i !== item) closeItem(i); });
    item.classList.add('is-open');
    var t = item.querySelector('[data-mega-trigger]');
    if (t) t.setAttribute('aria-expanded', 'true');
  }
  function closeItem(item) {
    item.classList.remove('is-open');
    var t = item.querySelector('[data-mega-trigger]');
    if (t) t.setAttribute('aria-expanded', 'false');
  }
  function closeAllMega() {
    clearTimeout(megaOpenTimer);
    clearTimeout(megaCloseTimer);
    navItems.forEach(closeItem);
  }

  navItems.forEach(function (item) {
    var trigger = item.querySelector('[data-mega-trigger]');
    if (!trigger) return;

    if (hoverCapable) {
      // Open ONLY when the cursor is genuinely over the trigger link (short intent delay).
      trigger.addEventListener('mouseenter', function () {
        clearTimeout(megaCloseTimer);
        clearTimeout(megaOpenTimer);
        megaOpenTimer = setTimeout(function () { openItem(item); }, 70);
      });
      // Abort a pending open if the cursor leaves the link before it opens.
      trigger.addEventListener('mouseleave', function () { clearTimeout(megaOpenTimer); });
      // Close when leaving the whole nav item (link + panel), with a small forgiveness delay.
      item.addEventListener('mouseleave', function () {
        clearTimeout(megaOpenTimer);
        clearTimeout(megaCloseTimer);
        megaCloseTimer = setTimeout(function () { closeItem(item); }, 160);
      });
      item.addEventListener('mouseenter', function () { clearTimeout(megaCloseTimer); });
      // Keyboard focus opens; moving focus out of the item closes.
      trigger.addEventListener('focus', function () { openItem(item); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closeItem(item);
      });
    }

    // Touch / non-hover devices: first tap opens, second tap follows the link.
    trigger.addEventListener('click', function (e) {
      if (!hoverCapable) {
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          closeAllMega();
          openItem(item);
        }
      }
    });

    // Escape closes and returns focus to the trigger.
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeItem(item); trigger.focus(); }
    });
  });

  // Click outside closes any open mega panel.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.Header__NavItem.has-mega')) closeAllMega();
  });

  // Mobile drawer accordion
  var accToggles = document.querySelectorAll('[data-mobile-acc]');
  accToggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = btn.parentElement.querySelector('[data-mobile-sub]');
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      // close siblings for an accordion feel
      accToggles.forEach(function (other) {
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          var os = other.parentElement.querySelector('[data-mobile-sub]');
          if (os) os.classList.remove('is-open');
        }
      });
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (sub) sub.classList.toggle('is-open', !isOpen);
    });
  });
});

/* ==========================================
   COLOR SWATCHES — card image-swap + variant select
   ========================================== */
document.addEventListener('DOMContentLoaded', function () {
  var cards = document.querySelectorAll('.product-card');
  if (!cards.length) return;

  var hoverCapable = window.matchMedia &&
    window.matchMedia('(hover: hover)').matches;

  cards.forEach(function (card) {
    var swatches = card.querySelectorAll('.pc-swatch');
    if (!swatches.length) return;

    var primaryImg = card.querySelector('.product-img-primary');
    var quickAdd = card.querySelector('.product-quick-add');

    // Stash the original image src so we can restore it.
    if (primaryImg && primaryImg.tagName === 'IMG' && !primaryImg.getAttribute('data-original-src')) {
      primaryImg.setAttribute('data-original-src', primaryImg.getAttribute('src') || '');
    }

    function applySwatch(swatch, commit) {
      var img = swatch.getAttribute('data-img');
      if (img && primaryImg && primaryImg.tagName === 'IMG') {
        primaryImg.src = img;
      }
      if (commit && quickAdd) {
        var vid = swatch.getAttribute('data-variant-id');
        if (vid) quickAdd.setAttribute('data-variant-id', vid);
      }
    }

    function select(swatch) {
      swatches.forEach(function (s) { s.classList.remove('is-active'); });
      swatch.classList.add('is-active');
      applySwatch(swatch, true);
    }

    function activeSwatch() {
      for (var i = 0; i < swatches.length; i++) {
        if (swatches[i].classList.contains('is-active')) return swatches[i];
      }
      return null;
    }

    swatches.forEach(function (swatch) {
      // CLICK commits the selection (works on touch + desktop).
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        select(swatch);
      });

      // Hover preview only on hover-capable devices.
      if (hoverCapable) {
        swatch.addEventListener('mouseenter', function () {
          applySwatch(swatch, false);
        });
      }
    });

    // On leaving the card, restore the committed (active) swatch image,
    // or fall back to the original image.
    if (hoverCapable) {
      card.addEventListener('mouseleave', function () {
        var active = activeSwatch();
        if (active && active.getAttribute('data-img') && primaryImg && primaryImg.tagName === 'IMG') {
          primaryImg.src = active.getAttribute('data-img');
        } else if (primaryImg && primaryImg.tagName === 'IMG') {
          var orig = primaryImg.getAttribute('data-original-src');
          if (orig) primaryImg.src = orig;
        }
      });
    }
  });
});

/* ==========================================
   RECENTLY VIEWED PRODUCTS
   ========================================== */
document.addEventListener('DOMContentLoaded', function () {
  var STORE_KEY = 'sa_recently_viewed';
  var CAP = 12;

  function readStore() {
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }

  function writeStore(arr) {
    try { window.localStorage.setItem(STORE_KEY, JSON.stringify(arr)); } catch (e) {}
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function rvFormatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var fmt = window.SA_MONEY_FORMAT;
    if (fmt && typeof fmt === 'string') {
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, token) {
        if (token.indexOf('no_decimals') !== -1) return Math.round(cents / 100).toString();
        return amount;
      });
    }
    return '₹' + amount;
  }

  function rvAddToCart(variantId, qty) {
    if (!variantId) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function () {
      // Nudge the cart drawer / count to refresh if present.
      var bagTrigger = document.querySelector('#nav-bag-trigger');
      if (bagTrigger) bagTrigger.click();
    }).catch(function () {});
  }

  // --- Track current product handle on PDP ---
  var pdpInfo = document.querySelector('.product-info-sticky[data-product-handle]');
  var currentHandle = pdpInfo ? pdpInfo.getAttribute('data-product-handle') : null;
  if (currentHandle) {
    var list = readStore().filter(function (h) { return h !== currentHandle; });
    list.unshift(currentHandle);
    if (list.length > CAP) list = list.slice(0, CAP);
    writeStore(list);
  }

  // --- Render strip ---
  var grid = document.querySelector('#recently-viewed-grid');
  if (!grid) return;
  var wrap = grid.closest('[data-recently-viewed]');
  var limit = wrap ? parseInt(wrap.getAttribute('data-limit'), 10) : 4;
  if (isNaN(limit) || limit < 1) limit = 4;

  var handles = readStore().filter(function (h) {
    return h && h !== currentHandle;
  }).slice(0, limit);

  if (!handles.length) return;

  // Market product-tag filter: a product tagged "market:<other>" is exclusive
  // to that market and must be hidden when SA_MARKET is a different handle.
  function isHiddenInMarket(product) {
    var market = window.SA_MARKET;
    if (!market || !product || !Array.isArray(product.tags)) return false;
    var allowed = 'market:' + market;
    var hasMarketTag = false;
    var inMarket = false;
    for (var i = 0; i < product.tags.length; i++) {
      var tag = String(product.tags[i]);
      if (tag.indexOf('market:') !== -1) {
        hasMarketTag = true;
        if (tag === allowed) inMarket = true;
      }
    }
    return hasMarketTag && !inMarket;
  }

  function buildCard(product) {
    if (!product || !product.handle) return null;
    if (isHiddenInMarket(product)) return null;
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var imgTag = img
      ? '<img src="' + escapeHtml(img) + '" class="product-img-primary" alt="' +
          escapeHtml(product.title) + '" loading="lazy">'
      : '<span class="product-img-primary"></span>';

    var variant = null;
    if (product.variants && product.variants.length) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) { variant = product.variants[i]; break; }
      }
      if (!variant) variant = product.variants[0];
    }
    var available = variant && variant.available;
    var addBtn = (variant && available)
      ? '<button type="button" class="product-quick-add" data-variant-id="' + variant.id + '">ADD TO BAG</button>'
      : '<button type="button" class="product-quick-add" disabled>SOLD OUT</button>';

    var price = (typeof product.price !== 'undefined' && product.price !== null)
      ? rvFormatMoney(product.price) : '';

    var card = document.createElement('div');
    card.className = 'product-card';
    card.innerHTML =
      '<div class="product-img-wrap">' + imgTag + addBtn + '</div>' +
      '<div class="product-info">' +
        '<a href="/products/' + escapeHtml(product.handle) + '" class="product-title">' +
          escapeHtml(product.title) + '</a>' +
        (price ? '<span class="product-price">' + price + '</span>' : '') +
      '</div>';

    var btn = card.querySelector('.product-quick-add');
    if (btn && !btn.disabled) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var vid = btn.getAttribute('data-variant-id');
        if (vid) rvAddToCart(vid, 1);
      });
    }
    return card;
  }

  var fetches = handles.map(function (handle) {
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  });

  Promise.all(fetches).then(function (products) {
    var added = 0;
    products.forEach(function (product) {
      var card = buildCard(product);
      if (card) { grid.appendChild(card); added++; }
    });
    if (added > 0 && wrap) {
      wrap.style.display = '';
    }
  });
});

/* ==========================================
   MEGA-MENU PREVIEW SWAP (hover a collection → show its glimpse)
   ========================================== */
document.addEventListener('DOMContentLoaded', function () {
  var panels = document.querySelectorAll('.Header__NavItem.has-mega');
  panels.forEach(function (navItem) {
    var triggers = navItem.querySelectorAll('[data-mega-preview]');
    var previews = navItem.querySelectorAll('[data-mega-preview-panel]');
    if (!triggers.length || !previews.length) return;

    function activate(handle) {
      triggers.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-mega-preview') === handle);
      });
      previews.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-mega-preview-panel') === handle);
      });
    }

    triggers.forEach(function (t) {
      var handle = t.getAttribute('data-mega-preview');
      t.addEventListener('mouseenter', function () { activate(handle); });
      t.addEventListener('focus', function () { activate(handle); });
    });
  });
});

/* ==========================================
   BRAND LOADER — hide once loaded (with safety timeout)
   ========================================== */
(function () {
  var loader = document.getElementById('sa-loader');
  if (!loader) return;
  var hidden = false;
  function hideLoader() {
    if (hidden) return;
    hidden = true;
    loader.classList.add('is-hidden');
    document.body.classList.add('sa-loaded');
    setTimeout(function () { if (loader && loader.parentNode) loader.parentNode.removeChild(loader); }, 700);
  }
  // Hide a touch after load so the mark is briefly visible; cap with a fallback.
  window.addEventListener('load', function () { setTimeout(hideLoader, 450); });
  setTimeout(hideLoader, 3500); // safety net if 'load' never fires
})();
